import { IconToggleLeft } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { ToggleCaptureBlock as RenderToggleCaptureBlock } from '../../templateRenderer/CaptureBlocks/ToggleCaptureBlock'
import { DisplayBlock, ToggleCaptureBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  InputField,
  SelectField,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<ToggleCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'toggle' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Toggle',
    icon: IconToggleLeft,
    helpText: 'Yes or no, On or off, etc',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'onLabel',
      label: 'On label',
      field: InputField,
    },
    {
      name: 'offLabel',
      label: 'Off label',
      field: InputField,
    },
    {
      name: 'defaultState',
      label: 'Default state',
      field: SelectField,
      options: [
        { value: 'on', label: 'On' },
        { value: 'off', label: 'Off' },
      ],
    },
  ]

  public override mapFormValueToBlock(
    block: ToggleCaptureBlock,
    value: boolean,
    returnDefaultValue?: boolean
  ): ToggleCaptureBlock {
    if (value === undefined || returnDefaultValue) {
      return { ...block, value: block.defaultState || 'off' }
    }

    return { ...block, value: value ? 'on' : 'off' }
  }

  public override mapBlockToDisplayBlock(
    block: ToggleCaptureBlock
  ): DisplayBlock {
    const { onLabel, offLabel, value, ...restOfBlock } = block

    const onText = onLabel ?? 'On'
    const offText = offLabel ?? 'Off'

    return {
      ...restOfBlock,
      type: 'text',
      kind: 'display',
      content: value === 'on' ? onText : offText,
    }
  }

  public override renderBlock(
    block: ToggleCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderToggleCaptureBlock block={block} rules={rules} />
  }
}

export const ToggleCaptureBlockConfig = new Config()
